import React from 'react';
import { BlackButton } from '../buttons/buttons.js';
import style from './mobileResume.module.scss';

export default function MobileResume({ handleClick }) {
  return (
    <section className={style.mobileResume}>
      <h2>Selected Experience</h2>
      <hr className={style.lineBreak} />
      <article>
        <h3 className={style.firstH3}>
          Lead User Researcher/Designer, <span>Agile Six</span>
        </h3>
        <h4>April 2025 – Present · Civic tech, human-centered design at the VA — Benefits Portfolio: Decision Reviews</h4>
        <ul>
          <li>
            <b>Led UX design and research</b> on the Decision Reviews team at the U.S. Dept. of Veterans Affairs to
            support the digital experience of three forms with a combined 226.8k annual submissions
          </li>
          <li>
            <b>Collaborated with key stakeholders</b> including the Board of Veterans Affairs, Office of Administrative
            Review, and Office of General Counsel to ensure legal compliance of new feature design and information
            architecture
          </li>
          <li>
            <b>Leveraged diverse AI tools</b> to support research and documentation and improve systems and processes
          </li>
          <li>
            <b>Mentored the internal UX team</b> in Figma skills, leveraging the design system, clarifying research
            findings, and in effective collaboration with stakeholders
          </li>
          <li>
            <b>Identified, scoped, and redesigned key features</b> that reduced form abandonment rate by 3.2% in the
            Supplemental Claim digital form submission flow
          </li>
        </ul>
      </article>
      <article>
        <h3 className={style.firstH3}>
          Senior User Researcher/Designer, <span>Agile Six</span>
        </h3>
        <h4>Nov. 2024 – April 2025 · Civic tech, human-centered design at the VA — Benefits Portfolio: 526EZ Conditions</h4>
        <ul>
          <li>
            <b>Partnered strategically</b> with the U.S. Dept. of Veterans Affairs to advance goals, innovate UX, and
            ensure compliance of the end-to-end Veteran experience across the OCTO Benefits portfolio
          </li>
          <li>
            <b>Conducted qualitative and quantitative usability research</b>, with a focus on accessible technology, to
            evaluate design implementation, identify key user pain points, and inform product direction
          </li>
          <li>
            <b>Wrote comprehensive research documentation</b>, integrating feedback from key stakeholders to ensure
            alignment on product direction and government compliance
          </li>
          <li>
            <b>Iterative design for comprehensive user journeys</b>, creating decision trees and user journey maps and
            translating problems into hi-fidelity wireframes with strict adherence to the VA design system
          </li>
          <li>
            <b>Worked closely with data engineers</b> to improve contention classification from 30% to 65%
          </li>
        </ul>
      </article>
      <article>
        <h3 className={style.firstH3}>
          UX Designer, <span>RBA Consulting</span>
        </h3>
        <h4>
          Contract: May 2024 – Aug. 2025 · Healthtech, Minnesota Hospital Association — internal tools & website redesign
          & rebranding
        </h4>
        <ul>
          <li>
            <b>Led UX strategy</b> to inform scope, direction, and implementation of website and internal portal tool
            design for client, Minnesota Hospital Association
          </li>
          <li>
            <b>Conducted in-depth research strategy</b> to inform redesign by identifying and creating 10 personas and
            documenting 7+ complex user flows
          </li>
          <li>
            <b>Collaborated with the client</b> on branding re-design to ensure accessibility compliance, alignment with
            organizational mission, and scalability
          </li>
          <li>
            <b>End-to-end design</b> of website, portals, and dashboard to handle secure information while prioritizing
            ease of use for users
          </li>
        </ul>
      </article>
      <article>
        <h3 className={style.firstH3}>
          UX Designer, <span>Paradigm Technology</span>
        </h3>
        <h4>June 2024 – Nov. 2024 · Enterprise SaaS construction technology — redesign to modernize</h4>
        <ul>
          <li>
            <b>Advocated for UX integration</b> through direct collaboration with product teams to establish process and
            workflow to streamline UX outcomes and efficiency
          </li>
          <li>
            <b>Conducted in-depth audit</b> of internal tool to inform comprehensive user research strategy and create a
            backlog of modernization improvements
          </li>
          <li>
            <b>Collaborated with the design team</b> to work agilely across eight products that serve 10,000 customers and
            150,000+ end users
          </li>
          <li>
            <b>Modernized the design system</b> for the Estimate product to align with recently established company design
            system and ensure easier developer handoff
          </li>
        </ul>
      </article>
      <h2 className={style.second}>Education</h2>
      <hr className={style.lineBreak} />
      <article>
        <h3 className={style.firstH3}>UX Academy — Designlab</h3>
        <h4>UX Design Certificate</h4>
        <ul>
          <li>Completed 600+ hours of coursework, full-stack design training, and four capstone projects</li>
        </ul>
      </article>
      <article>
        <h3>Teaching License, K–12 Art Education</h3>
        <h4>Loyola Marymount University</h4>
      </article>
      <article>
        <h3>B.A. with honors, Fine Art / Gender Studies</h3>
        <h4>New College of Florida</h4>
      </article>
      <div className={style.buttonContainer}>
        <BlackButton onClick={handleClick} text="View Full Resume" />
      </div>
    </section>
  );
}
